<template>
  <el-card class="box-card card-cup">
    <div slot="header" class="clearfix">
      <span class='bid_item_title'>招标公告</span>
      <el-button @click="moreNote" class="bid_more" type="text">更多<i class="el-icon-arrow-right el-icon--right"></i></el-button>
    </div>
    <div v-for="(nItem,index) in bidNoteArr" :key="index" class="bid_note_item" @click="seeBidNote(nItem.bidsId)">
      <el-row>
        <el-col :span="19">
          <div class="bid_common_item">
            <!-- <span style="color:red;">【{{nItem.bidsKeys}}】</span> -->
            <span>{{nItem.bidsName}}</span>
          </div>
        </el-col>
        <el-col :span="5">{{nItem.promTime}}</el-col>
      </el-row>
    </div>
    <div v-show="isNotePage" class="bid_pagination">
      <el-pagination @size-change="sizeChangeCtl" @current-change="pageTurn" :current-page="pageSize" :page-sizes="[10, 20, 30]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="pageNoSum">
      </el-pagination>
    </div>
  </el-card>
</template>
<script>
import { bidList } from '@/api/frontApi/bidding';
export default {
  data() {
    return {
      isNotePage: false,
      bidNoteArr: [],
      pageNoSum: 0,
      pageSize: 10,
      pageNo: 1
    };
  },
  created() {
    this.initBidNoteData(1, 5, null);
  },
  methods: {
    initBidNoteData(pageNo, pageSize, flag) {
      if (flag) this.isNotePage = flag;
      else this.isNotePage = false;
      bidList(pageNo, pageSize, 1).then(res => {
        this.bidNoteArr = [];
        this.pageNoSum = parseInt(res.data.pageTotal);
        this.bidNoteArr = res.data.list;
      });
    },
    seeBidNote(noteId) {
      if (noteId) {
        this.$router.push({
          name: 'biddingInfo',
          params: {
            bidId: noteId,
            itemNmae: '招标公告'
          }
        });
      }
    },
    moreNote() {
      this.$emit('sendBack', 1);
      this.initBidNoteData(1, this.pageSize, true);
    },
    sizeChangeCtl(val) {
      this.pageSize = val;
      this.initBidNoteData(this.pageNo, this.pageSize, true);
    },
    pageTurn(val) {
      this.pageNo = val;
      this.initBidNoteData(this.pageNo, this.pagSize, true);
    }
  }
};
</script>
<style lang="stylus" scoped>
.bid_note_item {
  height: 28px;
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/bidding/bidNote.vue